import { Actions } from '@components/shared/Actions'
import { EditIcon } from '@assets/svgs/EditIcon'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { DetailedSummaryDepreciationItemProps } from '../context/types'

interface ParseDetailedSummaryProps {
  data: DetailedSummaryDepreciationItemProps[]
  onEdit: (data: DetailedSummaryDepreciationItemProps) => void
  actionsDisabled: boolean
}

export const parseDetailedSummaryGrid = ({ data, actionsDisabled, onEdit }: ParseDetailedSummaryProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'accountingCode',
      columnName: 'Conta',
      align: 'center',
      value: item.accountingCode || '-',
      minWidth: '8rem',
      sortable: true
    },
    {
      id: 'accountingDescription',
      columnName: 'Descrição Conta',
      align: 'center',
      value: item.accountingDescription || '-',
      minWidth: '22rem',
      sortable: true
    },
    {
      id: 'depreciationValue',
      columnName: 'Valor Depreciação (R$)',
      align: 'center',
      currency: true,
      value: item.depreciationAmount || 0,
      minWidth: '14rem',
      sortable: true
    },
    {
      id: 'observations',
      columnName: 'Observações',
      align: 'center',
      value: item.observations || '-',
      minWidth: '22rem',
      sortable: true
    },
    {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: (
        <Actions
          actions={[{ label: 'Editar', icon: <EditIcon />, onClick: () => onEdit(item) }]}
          disabled={actionsDisabled}
        />
      )
    }
  ])

  return parsedData
}
